import React, { useState } from 'react'
import Navibar from './Navibar'
import styles from './styles/Home.module.css'
import ShowcaseFooter from './Footer'
import ContactForm from './ContactForm'
import { FacebookOutlined, InstagramOutlined, LinkedinOutlined } from '@ant-design/icons'
import { Button, Popover } from 'antd'
import ContactSocialForm from './ContactSocialForm'

export default function ContactPage(props) {
  const [socialEditVisible, setSocialEditVisible] = useState(false)

  const editLayout = () => {
    return (
      <div style={{ padding: 12, marginBottom: 0 }}>
        <Button
          type={'primary'}
          onClick={() => {
            setSocialEditVisible(true)
          }}
        >
          Edit
        </Button>
      </div>
    )
  }

  const onCancel = () => {
    setSocialEditVisible(false)
  }

  const onContactSocialSubmit = (data) => {
    setSocialEditVisible(false)
    if (props.onContactSocialSubmit) props.onContactSocialSubmit(data)
  }

  const onContactFormSubmit = (data) => {
    if (props.onContactFormSubmit) props.onContactFormSubmit(data)
  }

  return (
    <div style={{ overflowX: 'hidden' }}>
      <Navibar {...props} />
      <main className={styles.main}>
        <ContactSocialForm
          visible={socialEditVisible}
          onCancel={onCancel}
          onSubmit={onContactSocialSubmit}
          data={{
            social_instagram: props.social_instagram ?? '',
            social_facebook: props.social_facebook ?? '',
            social_linkedin: props.social_linkedin ?? ''
          }}
        />
        <div
          style={{
            marginLeft: '6rem',
            marginRight: '6rem',
            paddingLeft: '6rem',
            paddingRight: '6rem',
            paddingTop: 48,
            paddingBottom: 64
          }}
        >
          <center>
            <o style={{ fontSize: 36, fontWeight: 400, lineHeight: 1.5 }}>FOR INQUIRIES AND COLLABORATIONS</o>
          </center>
          <center>
            <h1 style={{ fontSize: 36, fontWeight: 400, lineHeight: 1.5, paddingBottom: 24 }}>REACH ME HERE</h1>
          </center>
          <ContactForm onSubmit={onContactFormSubmit} />
        </div>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <Popover content={editLayout()}>
            <div style={{ display: 'flex', gap: 16, marginTop: 36 }}>
              <a href={'https://' + (props.social_instagram ?? '')} style={{ color: 'black' }} target={'_blank'}>
                <InstagramOutlined style={{ fontSize: 24 }} />{' '}
              </a>
              <a href={'https://' + (props.social_facebook ?? '')} style={{ color: 'black' }} target={'_blank'}>
                <FacebookOutlined style={{ fontSize: 24 }} />{' '}
              </a>
              <a href={'https://' + (props.social_linkedin ?? '')} style={{ color: 'black' }} target={'_blank'}>
                <LinkedinOutlined style={{ fontSize: 24 }} />{' '}
              </a>
            </div>
          </Popover>
        </div>
      </main>
      <ShowcaseFooter />
    </div>
  )
}
